import { render, staticRenderFns } from "./MonitorServiceProcessPage.vue?vue&type=template&id=1505784a&scoped=true&"
import script from "./MonitorServiceProcessPage.vue?vue&type=script&lang=js&"
export * from "./MonitorServiceProcessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505784a",
  null
  
)

export default component.exports